export default (el, scrollContainer = window) => {
	if (el) {
		const bcr = el.getBoundingClientRect();
		const scrollPos = {
			scrollTop: bcr.top + scrollContainer.scrollY,
			scrollBottom: bcr.top + scrollContainer.scrollY + bcr.height,
			scrollLeft: bcr.left + scrollContainer.scrollX,
			scrollRight: bcr.left + scrollContainer.scrollX + bcr.width
		};
		return scrollPos;
	}
};
